import React from "react";
import { ShiOnePermission } from "../../../../../auth/authorizationTypes";
import BarChartIcon from "@mui/icons-material/BarChart";
import { useClaims } from "../../../../../auth/ClaimsProvider";

export function useGetReportsNavItems() {
  const { hasPermission } = useClaims();
  return [
    {
      id: "divider-section-2",
      type: "Divider",
      displayName: "",
      visible: true,
    },
    {
      id: "reports",
      type: "Link",
      displayName: "Report Center",
      visible: hasPermission(ShiOnePermission.reportRead),
      icon: <BarChartIcon />,
      path: "/report-center",
    },
  ];
}
